import getQueryParams from '@/utilities/getters/getQueryParams';
import { resolveRouterBasename } from '@/utilities/helpers/same-origin-path';

/**
 * Reads the launch gameUid from the current URL synchronously.
 * Used when React Router params lag behind an in-place history update
 * (e.g. recently played route sync before soft reload).
 */
const resolveLaunchGameUidFromLocation = (): string | null => {
  const queryUid = getQueryParams('gameUid');
  if (queryUid) {
    return queryUid;
  }

  const basename = resolveRouterBasename(window.location.pathname);
  let path = window.location.pathname;
  if (basename && path.startsWith(basename)) {
    path = path.slice(basename.length) || '/';
  }

  const segment = path.split('/').filter(Boolean)[0];
  return segment ?? null;
};

export default resolveLaunchGameUidFromLocation;
